var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-footer", { staticClass: "my_footer" }, [
    _c(
      "div",
      { staticStyle: { height: "277px", width: "1920px", margin: "0 auto" } },
      [
        _c("ul", [
          _c("li", {}, [_vm._v(_vm._s(_vm.$t("footer.yeerGene")))]),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.guanyuClick }
            },
            [_vm._v(_vm._s(_vm.$t("footer.aboutUs")))]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.guanwClick }
            },
            [_vm._v(_vm._s(_vm.$t("footer.officialWebsite")))]
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v(_vm._s(_vm.$t("footer.productsServices")))]),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function($event) {
                  return _vm.ngClick("n")
                }
              }
            },
            [_vm._v("NGSure")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function($event) {
                  return _vm.auClick("a")
                }
              }
            },
            [_vm._v("Augury")]
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [_vm._v(_vm._s(_vm.$t("footer.technicalSupport")))]),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.contactClick }
            },
            [_vm._v(_vm._s(_vm.$t("footer.contactUs")))]
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticStyle: { "margin-right": "190px", float: "right" } }, [
          _c("li", [
            _c("img", {
              staticStyle: { width: "294px", height: "135px" },
              attrs: { src: require("../../assets/images/pin.png") }
            })
          ]),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: {
                height: "28px",
                "font-size": "15px",
                "font-family": "PingFangSC-Regular, PingFang SC",
                "font-weight": "400",
                color: "rgba(255,255,255,0.7)",
                "line-height": "28px",
                margin: "16px 0",
                "margin-top": "100px",
                float: "left"
              }
            },
            [_vm._v("阅尔基因官方公众号")]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticStyle: {
                height: "28px",
                "font-size": "15px",
                "font-family": "PingFangSC-Regular, PingFang SC",
                "font-weight": "400",
                color: "rgba(255,255,255,0.7)",
                "line-height": "28px",
                margin: "16px 0",
                "margin-top": "100px",
                float: "right"
              }
            },
            [_vm._v("阅尔基因学术公众号")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "my_footer_path" }, [
      _c("div", { staticStyle: { width: "1920px", margin: "auto" } }, [
        _c("li", { staticClass: "my_footer_d" }, [
          _vm._v(
            "\n            上海阅尔基因技术有限公司 沪公网安备31011002005278号 沪ICP备17045756号-2\n          "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-right": "200px" } }, [
          _c("li", { staticClass: "my_footer_f" }, [
            _vm._v("\n              Powered by WizInno\n")
          ]),
          _vm._v(" "),
          _c("li", {
            staticClass: "my_footer_f",
            staticStyle: { "margin-right": "-5px" }
          }),
          _vm._v(" "),
          _c("li", {
            staticClass: "my_footer_f",
            staticStyle: { "margin-right": "-5px" }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d73c3ad2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d73c3ad2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/footer.vue
// module id = null
// module chunks = 